import React, { useState, useEffect } from "react";
import Select from "react-select";

const UserDropdown = ({ selectedUsers, setSelectedUsers, handleSelectUser, handleRemoveUser }) => {
    const [users, setUsers] = useState([]); // All users from the backend
    const [options, setOptions] = useState([]); // Filtered options for dropdown
    const [searchTerm, setSearchTerm] = useState(""); // Search term
  
    // Fetch user data from the backend
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/summary`)
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            const userOptions = data.map(([userId, username]) => ({
              value: userId,
              label: `${username} (${userId})`,
            }));
            setUsers(userOptions);
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }, []);
  
    // Filter options based on the search term
    useEffect(() => {
      const filteredOptions = users
        .filter(
          (user) =>
            user.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
            !selectedUsers.some((selected) => selected.value === user.value)
        )
        .slice(0, 5); // Limit to 5 options
      setOptions(filteredOptions);
    }, [searchTerm, users, selectedUsers]);
  
    return (
      <div>
        <Select
          options={options}
          onInputChange={(input) => setSearchTerm(input)}
          onChange={(selectedOption) => {
            handleSelectUser(selectedOption);
            setSearchTerm(""); // Clear the search term after selecting
          }}
          placeholder="Search users..."
          isSearchable
        />
        
        <div style={{ marginTop: "20px" }}>
          <h4>Select co-author from Sona</h4>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {selectedUsers.map((user) => (
              <li key={user.value} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <span>{user.label}</span>
                <button
                  style={{
                    color: "red",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "1px solid red",
                    backgroundColor: "transparent",
                    borderRadius: "5px",
                  }}
                  onClick={() => handleRemoveUser(user.value)} // Remove user from selected list
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };
  
  export default UserDropdown;
  


